import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from "@mui/material";
import axios from 'axios';
import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { createFacility, updateFacility } from 'actions/action';
import { Toaster, toast } from 'react-hot-toast';
import { getFacility } from 'actions/action';
import { imageBaseURL } from 'actions/Base_URL';
import SubmittingModal from 'components/Modal';

export default function CreateFacilities() {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, id } = location.state;
  const [formData, setFormData] = useState({
    facility_name: "",
    location: "",
    capacity: "",
    start_time: "",
    end_time: "",
    //slots_timing: "",
    description: "",
    facility_images: [],
    existing_images: []
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Form value handler
  function getFormValues(e) {
    const { name, value } = e.target;
    if (name === "facility_images") {
      const files = e.target.files;
      setFormData({ ...formData, [name]: files });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  }

  // Validate the form data
  const validate = () => {
    let newErrors = {};
    if (!formData.facility_name) newErrors.facility_name = "Facility name is required";
    if (!formData.location) newErrors.location = "Location is required";
    if (!formData.capacity) newErrors.capacity = "Capacity is required";
    //if (!formData.slots_timing) newErrors.slots_timing = "Slot timing is required";
    if (!formData.start_time) newErrors.start_time = "Start date is required";
    if (!formData.end_time) newErrors.end_time = "End date is required";
    if (type === "create" && formData.facility_images.length === 0) newErrors.facility_images = "Facility image is required";
    if (!formData.description) newErrors.description = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmitFormData = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);
      const dataToSend = new FormData();
      dataToSend.append("facility_name", formData.facility_name);
      dataToSend.append("location", formData.location);
      dataToSend.append("capacity", formData.capacity);
      dataToSend.append("start_time", formData.start_time);
      dataToSend.append("end_time", formData.end_time);
      dataToSend.append("description", formData.description);

      // if(formData.facility_images && formData.facility_images.length !== 0){
      //   Array.from(formData.facility_images).forEach((image) => {
      //       dataToSend.append("facility_images", image); // append all selected images
      //     });
      // }

      if (formData.facility_images && formData.facility_images.length > 0) {
        Array.from(formData.facility_images).forEach((image) => {
          if (image instanceof File && image.type.startsWith("image/")) {
            dataToSend.append("facility_images", image);
          }
        });
      }
      // if(formData.existing_images && formData.existing_images.length !== 0){
      //   Array.from(formData.existing_images).forEach((image) => {
      //       dataToSend.append("existing_images", image); // append all selected images
      //     });
      // }
      if (formData.existing_images && formData.existing_images.length > 0) {
        dataToSend.append(
          "existing_images",
          JSON.stringify(formData.existing_images)
        );
      }

      if (type === "create") {
        const res = await createFacility(dataToSend);
        if (res.status === 201 || res.status === 200) {
          toast.success("Facility Created Successfully!");
        } else {
          toast.error(res.err);
        }
      } else {
        const res = await updateFacility(dataToSend, id);
        if (res.success) {
          toast.success("Facility Updated Successfully!");
        } else {
          toast.error(res.err);
        }
      }
      navigate("/admin/facilities");
    } catch (error) {
      console.error("Error creating facility:", error);
      alert("Failed to create facility. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      existing_images: prevFormData.existing_images.filter((_, index) => index !== indexToRemove),
    }));
  };

  const fetchFacility = async () => {
    try {
      const response = await getFacility(id);

      if (response.status === 200) {
        const data = response.data.data;

        const formattedData = {
          ...data,
          existing_images: response.data.data.facility_images,
          //slots_timing: data.slots_timing.replace(/"/g, ''), 
          start_time: response.data.data.start_time || '',
          end_time: response.data.data.end_time || '',
        };

        setFormData(formattedData);
      }
    } catch (error) {
      console.error("Error fetching facility data:", error);
      toast.error("Failed to fetch facility data. Please try again.");
    }
  };

  useEffect(() => {
    if (type === "edit") fetchFacility();
  }, [])
  const getRole = () => {
    const token = localStorage.getItem("token");;
    if (!token) return null;
    try {
      return jwtDecode(token).role;
    } catch {
      return null;
    }
  };
  const role = getRole();
  console.log(formData);
  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <SubmittingModal loading={loading} />
      <div className="flex justify-center items-center">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-dark-secondary border-0">
          <div className="rounded-t bg-dark-tertiary mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-white text-xl font-bold">{type === "create" ? "Create Facility" : "Update Facility"}</h6>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 className="text-gray-400 text-1xl mt-3 mb-6 font-bold ">Facility Information</h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-gray-300 text-xs font-bold mb-2">Facility Name <span className="text-red-500">*</span></label>
                    <input
                      placeholder="Facility Name"
                      className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="text"
                      name="facility_name"
                      value={formData.facility_name}
                      onChange={getFormValues}
                    />
                    {errors.facility_name && <p className="text-red-500 text-xs">{errors.facility_name}</p>}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-gray-300 text-xs font-bold mb-2">Location <span className="text-red-500">*</span></label>
                    <input
                      placeholder="Location"
                      className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={getFormValues}
                    />
                    {errors.location && <p className="text-red-500 text-xs">{errors.location}</p>}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-gray-300 text-xs font-bold mb-2">Facility Image <span className="text-red-500">*</span></label>
                    <input
                      placeholder="Location"
                      className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="file"
                      accept="image/*"
                      multiple
                      name="facility_images"
                      onChange={getFormValues}
                    />
                    {errors.facility_images && <p className="text-red-500 text-xs">{errors.facility_images}</p>}
                  </div>
                </div>
                {type === "edit" ? (
                  <>
                    <div className="w-full lg:w-8/12 px-4">
                      <div className="relative w-full mb-3">
                        <label className="block text-gray-300 text-xs font-bold mb-2">Existing Image</label>
                        {formData.existing_images && formData.existing_images.map((imageUrl, index) => {
                          const newImageUrl = imageUrl.replace(/^[^_]*_/, "");
                          return (
                            <>
                              <button
                                key={index}
                                type="button"
                                onClick={() => window.open(`${imageBaseURL}${imageUrl}`, "_blank")} // opens in new tab
                                className="w-10/12 bg-dark-primary text-white border border-white/10 rounded-md py-2 px-4 my-2 shadow hover:bg-white/5 transition"
                              >
                                {newImageUrl}
                              </button>
                              <button
                                type="button"
                                onClick={() => handleImageChange(index)}
                                className="w-2/12 bg-dark-primary text-red-400 hover:text-red-300 border border-white/10 rounded-md py-2 px-4 my-2 shadow hover:bg-white/5 transition"


                              >
                                ✕
                              </button>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">Facility Schedule</h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">Capacity <span className="text-red-500">*</span></label>
                    <input
                      placeholder="Capacity"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="text"
                      name="capacity"
                      value={formData.capacity}
                      onChange={getFormValues}
                    />
                    {errors.capacity && <p className="text-red-500 text-xs">{errors.capacity}</p>}
                  </div>
                </div>
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">Slot Timing</label>
                    <input
                      placeholder="Slot Timing"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="time"
                      name="slots_timing"
                      value={formData.slots_timing}
                      onChange={getFormValues}
                    />
                    {errors.slots_timing && <p className="text-red-500 text-xs">{errors.slots_timing}</p>}
                  </div>
                </div> */}
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">Start Date & Time <span className="text-red-500">*</span></label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="time"
                      name="start_time"
                      value={formData.start_time}
                      onChange={getFormValues}
                    />
                    {errors.start_time && <p className="text-red-500 text-xs">{errors.start_time}</p>}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">End Date & Time <span className="text-red-500">*</span></label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="time"
                      name="end_time"
                      value={formData.end_time}
                      onChange={getFormValues}
                    />
                    {errors.end_time && <p className="text-red-500 text-xs">{errors.end_time}</p>}
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">Description</h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">Description <span className="text-red-500">*</span></label>
                    <textarea
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Description"
                      rows="4"
                      name="description"
                      value={formData.description}
                      onChange={getFormValues}
                    />
                    {errors.description && <p className="text-red-500 text-xs">{errors.description}</p>}
                  </div>
                </div>
                <div className="flex justify-end w-full">
                  <Tooltip title="Back" arrow>
                    <button
                      className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => {
                        navigate(`/${role}/facilities`);
                      }
                      }
                    >
                      {"<< "}Back
                    </button>
                  </Tooltip>
                  {type !== 'view' ?
                    <>
                      <Tooltip title="Submit" arrow>
                        <button
                          className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold  text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"

                          onClick={onSubmitFormData}
                        >
                          {type === 'create' ? 'Submit' : 'Update'}
                        </button>
                      </Tooltip>
                      {/* <Tooltip title="Clear" arrow>
                      <button
                        className="bg-red-500 mt-10 text-white active:bg-lightBlue-600 font-semibold  text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          clearFormData()
                        }} >
                        Clear
                      </button>
                    </Tooltip> */}
                    </>
                    : ""}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
